import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";

import img_icon_thumbtack_empty from "@/Globals/_images/icons/thumbtack-empty.png";
import img_icon_thumbtack_full from "@/Globals/_images/icons/thumbtack-full.png";

interface PinItemControlProps {
    onPinItemClick: (isPinned: boolean) => void;
    isPinned: boolean;
    imageStyles?: React.CSSProperties;
}

class PinItemControl extends BaseReactComponent<PinItemControlProps, null> {
    public render(): JSX.Element {
        const imageStyles = this.props.imageStyles ?? { height: "20px", opacity: this.props.isPinned ? 1 : 0.4 };
        const imageSrc = this.props.isPinned
            ? img_icon_thumbtack_full
            : img_icon_thumbtack_empty;
        return (
            <div
                className="pointer"
                onClick={e => {
                    e.stopPropagation();
                    this.props.onPinItemClick(!this.props.isPinned);
                }}
            >
                <img
                    style={imageStyles}
                    src={imageSrc}
                />
            </div>
        );
    }
}

export { PinItemControl };
